package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_01_04_Day_1
import com.veldekar.components.logs.Log_2025_01_04_Day_2
import com.veldekar.components.logs.Log_2025_01_04_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-01-04")
@Composable
public fun Log_2025_01_04(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Arrival in Well's Bounty",
        ogTitle = "Arrival in Well's Bounty",
        date = LocalDate(2_025, 1, 4),
        ogDescription = "Bigglesworth survives and finds poop note.",
        ogImage = "ai/2025-01-04.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-69", dateString = "Newgrowth 69")
        Log_2025_01_04_Day_1()
        SessionDayHeader(dayId = "newgrowth-70", dateString = "Newgrowth 70")
        Log_2025_01_04_Day_2()
        SessionDayHeader(dayId = "newgrowth-71", dateString = "Newgrowth 71")
        Log_2025_01_04_Day_3()
    }
}
